export const uniSlash = url => url.replace(/\/\//g, '/')
